import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from './style/gstheme';
import PropTypes from 'prop-types';

class SecondaryButton extends React.Component {

  render() {

    const { classes, onClick, startIcon, endIcon, size, dataTest, disabled } = this.props;

    return (
      <Button
        disabled={disabled}
        data-test={dataTest}
        variant="contained"
        onClick={onClick}
        endIcon={endIcon}
        startIcon={startIcon}
        className={classes.secondaryButton}
        style={size === "wide" ? { width: '200px' } : {}}>
        {this.props.children}
      </Button>
    );
  }
}

SecondaryButton.defaultProps = {
  size: "standard",
  disabled: false
};

SecondaryButton.propTypes = {
  disabled: PropTypes.bool,
  dataTest: PropTypes.string,
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  endIcon: PropTypes.object,
  size: PropTypes.oneOf(["standard", "wide"]),
  startIcon: PropTypes.object,
  classes: PropTypes.object
};

export default withStyles(styles)(SecondaryButton);